document.addEventListener('DOMContentLoaded', () => {
    const trustSelectElement = document.querySelector(".c-trusts-widget__select");
    if (!trustSelectElement) return;

    trustSelectElement.addEventListener('change', (event) => {
        const selectedOption = event.target.querySelector('option:checked');
        const fundValue = selectedOption.value.trim();
        const fundDisplayName = selectedOption.textContent.trim();

        updateTrustFundDisplay(fundValue, fundDisplayName);
    });
});

function updateTrustFundDisplay(fundValue, fundDisplayName) {
    const trustFundNameElement = document.querySelector('.js-trustFundName');
    const trustFundValueElement = document.querySelector('.js-trustFundValue');
    const trustFundContentElement = document.querySelector('.js-trustFundContent');
    const trustFundResultsElement = document.querySelector('.js-showTrustFundResults');

    let normalizedDisplayName = fundDisplayName.replace(/\W/g, '');

    if (normalizedDisplayName === 'SelectTrust') {
        clearTrustFundFields(trustFundNameElement, trustFundValueElement, trustFundContentElement, trustFundResultsElement);
    } else {
        setTrustFundFields(fundValue, fundDisplayName, trustFundNameElement, trustFundValueElement, trustFundContentElement, trustFundResultsElement);
    }
}

function clearTrustFundFields(trustFundNameElement, trustFundValueElement, trustFundContentElement, trustFundResultsElement) {
    trustFundNameElement.textContent = '';
    trustFundValueElement.textContent = '';
    trustFundContentElement.textContent = '';
    trustFundResultsElement.style.display = "none";
}

function setTrustFundFields(fundValue, fundDisplayName, trustFundNameElement, trustFundValueElement, trustFundContentElement, trustFundResultsElement) {
    trustFundNameElement.textContent = fundDisplayName === 'Other' ? "Other" : `${fundValue}: `;
    trustFundValueElement.textContent = fundDisplayName === 'Other' ? '' : fundDisplayName;
    trustFundContentElement.textContent = fundDisplayName === 'Other' ?
        "Let's figure out if a trust exists, as well as other legal options." :
        "Wondering if you qualify? Let us help you find out!";
    trustFundResultsElement.style.display = "block";
}
